import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { LinearGradient } from 'expo-linear-gradient';
import { colors, formes, gradients, radius, spacing, typography } from '../theme/tokens';

// Bouton à contour dégradé charte (fond blanc, label sombre) + icône filled — technique border-gradient.
// Partagé par la notation de CV, l'entretien et « Modifier mon CV » (copies identiques jusqu'au 08/10/2026).
export function OutlineIconButton({
  label,
  icon,
  onPress,
  variante = 'degrade',
  testID,
}: {
  label: string;
  icon: React.ReactNode;
  onPress: () => void;
  // 'claire' : contour bleu pâle plein et libellé bleu profond, celui des écrans refaits.
  variante?: 'degrade' | 'claire';
  testID?: string;
}) {
  if (variante === 'claire') {
    return (
      <Pressable testID={testID} accessibilityRole="button" onPress={onPress} style={styles.outlineWrap}>
        <View testID={testID ? `${testID}-fond` : undefined} style={styles.claire}>
          {icon}
          <Text style={styles.claireLabel}>{label}</Text>
        </View>
      </Pressable>
    );
  }
  return (
    <Pressable testID={testID} accessibilityRole="button" onPress={onPress} style={styles.outlineWrap}>
      <LinearGradient colors={gradients.brand} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={styles.outlineBorder}>
        <View style={styles.outlineInner}>
          {icon}
          <Text style={styles.outlineLabel}>{label}</Text>
        </View>
      </LinearGradient>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  outlineWrap: { flex: 1 },
  outlineBorder: { borderRadius: radius.pill, padding: 1.5 },
  outlineInner: {
    minHeight: 48,
    borderRadius: radius.pill,
    backgroundColor: colors.white,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
  },
  claire: {
    minHeight: formes.cible,
    borderRadius: radius.pill,
    borderWidth: 1.5,
    borderColor: colors.bordureClaire,
    backgroundColor: colors.white,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm - 2,
    paddingHorizontal: spacing.md,
  },
  claireLabel: { fontSize: typography.small.size, fontWeight: '800', color: colors.electricDeep },
  outlineLabel: { fontSize: typography.small.size, fontWeight: '700', color: colors.night },
});
